<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableStorageGatewayDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['monitor:storageGatewayMonitor:delete']"
            @click="storageGatewayDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          v-hasPermission="[
            'monitor:storageGatewayMonitor:getStorageGatewayDetailById'
          ]"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="storageGatewayDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ domainName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeStorageGateway()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableStorageGatewayVue = {};
export default {
  name: "TableStorageGateway",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      storageGatewayDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      domainName: "",
      columns: [
        {
          title: this.$t("alarms.storagegateway.storageGatewayName"),
          key: "storageGatewayName"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.instance.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableStorageGatewayDate: []
    };
  },
  beforeCreate: function() {
    tableStorageGatewayVue = this;
  },
  created() {
    eventBus.$on("storageGatewayName", function(val) {
      tableStorageGatewayVue.storageGatewayName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableStorageGatewayVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableStorageGatewayVue.getStorageGatewayData();
    },
    // 分页显示数据
    /****************************************************/
    getStorageGatewayData: function() {
      //列表分页
      this.$api.storageGateway
        .pageStorageGateway({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableStorageGatewayVue.companyId,
          storageGatewayName: tableStorageGatewayVue.storageGatewayName
        })
        .then(res => {
          this.tableStorageGatewayDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableStorageGatewayVue.getStorageGatewayData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableStorageGatewayVue.getStorageGatewayData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
      eventBus.$off("storageGatewayName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.domainName = this.tableStorageGatewayDate[index].domainName;
    },
    removeStorageGateway: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.storageGateway
        .deleteStorageGateway("id", this.tableStorageGatewayDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableStorageGatewayVue.getStorageGatewayData();
            this.isDisable = false;
            this.modal_loading = false;
            this.storageGatewayDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/storageGatewayDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          name: row.storageGatewayName,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/storage_gateway/TableStorageGateway.vue